import React from 'react';
export default (function () {
  return /*#__PURE__*/React.createElement("div", {
    className: "cloud-ui-nav-menu-divider"
  });
});